export default function Card({ children, className = '', padding = true, ...props }) {
  return (
    <div
      className={`rounded-card border border-border-default bg-surface-card ${padding ? 'p-4 lg:p-5' : ''} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardHeader({ title, subtitle, action, className = '' }) {
  return (
    <div className={`flex items-start justify-between ${className}`}>
      <div>
        <h3 className="text-card-title font-display text-ink">{title}</h3>
        {subtitle && <p className="text-small mt-1 text-ink-muted">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function CardDivider() {
  return <hr className="my-4 border-border-default" />;
}
